/**
 * 充值
 * 目前包括 限时首充、连续充值
 */

import dayjs from 'dayjs';
import Decimal from 'decimal.js';
import { makeAutoObservable, reaction } from 'mobx';

import * as continueRechargeApi from '@/api/recharge/continue-recharge';
import * as firstRechargeApi from '@/api/recharge/first-recharge';
import { FIRST_RECHARGE_DAILY_FIRST_ENTER } from '@/constant/config';
import Storage from '@/utils/Storage';

// import { sleep } from '@/utils/utils';
import globalStore from './store';

const rechargeStore = makeAutoObservable({
  loaded: false,
  navbarClick: false,
  firstRecharge: {
    show: false,
    // 有可领取的奖金
    hasBonus: false,
    rechargeTime: '',
    rechargeAmount: 0,
    // hasUnread: false,
    dailyFirstEnter: Storage.get(FIRST_RECHARGE_DAILY_FIRST_ENTER),
    leftTime: 0,
    expdate: '',
    betaward_fetch: 0,
    betaward_can: 0,
    awad_7day_can: 0,
    days7: 0,
    fetch_days: 0,
    bet: 0,
    award7day: 0,
    awardbet40: 0,
    bet60awardflag: 0,
    activityAsideClick: false,
    // 数据是否加载，给首页的弹窗任务链使用，防止弹窗任务链开启了，数据还没加载
    ready: false
  },
  continueRecharge: {
    list: [],
    show: false,
    hasBonus: false,
    canRecharge: false,
    activityAsideClick: false
  } as any,
  updateContinueShow() {
    const list: any[] = rechargeStore.continueRecharge.list;
    const { vippoint } = globalStore.initialState;
    if (!list?.length) {
      rechargeStore.continueRecharge.show = vippoint > 0;
      return;
    }
    // @ts-ignore
    const lastRechargeTime = list.findLast(item => item.paytime)?.paytime;
    if (!lastRechargeTime) {
      rechargeStore.continueRecharge.show = vippoint > 0;
      return;
    }
    const isHide = dayjs().isAfter(dayjs(lastRechargeTime).add(10, 'day'));
    rechargeStore.continueRecharge.show = !isHide;
  },
  // 可充值
  updateContinueCanRecharge() {
    const list: any[] = rechargeStore.continueRecharge.list;
    // 此处只有三个列表，就不写的那么麻烦了，且根据业务很少会出现数量增加的情况，故简单粗暴即可
    if (!list[0].paytime) {
      rechargeStore.continueRecharge.canRecharge = true;
      return;
    }
    if (list[0].paytime && !list[1].paytime && dayjs().isBefore(dayjs(list[0].expdate))) {
      rechargeStore.continueRecharge.canRecharge = true;
      return;
    }

    if (list[1].paytime && !list[2].paytime && dayjs().isBefore(dayjs(list[1].expdate))) {
      rechargeStore.continueRecharge.canRecharge = true;
      return;
    }
    rechargeStore.continueRecharge.canRecharge = false;
  },
  // 可领取
  updateContinueHasBonus() {
    const list: any[] = rechargeStore.continueRecharge.list;
    const hasBonus = list.some(item => {
      if (item.betaward_can > 0) {
        return true;
      }
      const expired = dayjs().isAfter(dayjs(item.expdate));
      if (item.awardbet40_fetch > 0) {
        return false;
      }
      return expired
        ? !item.awardbet40_fetch && item.awardbet40 > 0
        : new Decimal(Math.min(item.payfee || 0, 1000))
            .mul(60)
            .minus(new Decimal(item.bet || 0).div(1000))
            .lte(0) &&
            !item.awardbet40_fetch &&
            item.awardbet40 > 0;
    });
    rechargeStore.continueRecharge.hasBonus = hasBonus;
  },
  updateFirstRechargeShow() {
    const { registerDate, vippoint } = globalStore.initialState;
    if (this.firstRecharge.rechargeTime) {
      const rechargeTimeDiff = dayjs(this.firstRecharge.rechargeTime).add(10, 'day').diff(dayjs());
      if (rechargeTimeDiff / (1000 * 60 * 60) >= 0) {
        this.firstRecharge.show = true;
        this.firstRecharge.leftTime = rechargeTimeDiff;
      }

      return;
    }

    // 未充值的vip
    if (!this.firstRecharge.rechargeTime && vippoint > 0) {
      this.firstRecharge.show = false;
      return;
    }

    const diffRegister = dayjs().diff(dayjs(registerDate));
    // 距离现在不超过两小时
    if (diffRegister / (1000 * 60 * 60) <= 2) {
      this.firstRecharge.show = true;
      this.firstRecharge.leftTime = 1000 * 60 * 60 * 2 - diffRegister;
      return;
    }

    const { last } = this.firstRecharge.dailyFirstEnter || {};
    if (!last) {
      // 这个实测进不来，因为app先加载，但是还是写在这里防止遗漏
      this.firstRecharge.show = true;
      this.firstRecharge.leftTime = 1000 * 60 * 60 * 2;
      return;
    }

    // 当天的2小时可可看见
    const diffLast = dayjs().diff(dayjs(last));
    if (diffLast / (1000 * 60 * 60) <= 2) {
      this.firstRecharge.show = true;
      this.firstRecharge.leftTime = 1000 * 60 * 60 * 2 - diffLast;
      return;
    }
  },
  updateFirstRechargeHasBonus() {
    const { firstRecharge } = rechargeStore;
    // if (!firstRecharge.rechargeAmount) {
    //   this.firstRecharge.hasBonus = true;
    //   return;
    // }

    if (
      firstRecharge.days7 > firstRecharge.fetch_days &&
      firstRecharge.days7 < 8 &&
      dayjs(firstRecharge.rechargeTime).get('date') !== dayjs().get('date')
    ) {
      this.firstRecharge.hasBonus = true;
      return;
    }

    if (firstRecharge.bet60awardflag === 1 && firstRecharge.awardbet40 <= 0) {
      this.firstRecharge.hasBonus = true;
      return;
    }

    if (firstRecharge.betaward_can) {
      this.firstRecharge.hasBonus = true;
      return;
    }

    this.firstRecharge.hasBonus = false;
  },
  async updateFirstRechargeData() {
    const {
      record: [data]
    } = await firstRechargeApi.getFirstRecharge();
    // const data = {
    //   paytime: '2024-08-05 14:45:43',
    //   bet: 0,
    //   expdate: '2024-08-12 14:45:43',
    //   days7: 1,
    //   awardbet40: 0,
    //   fetch_days: 0,
    //   award7day: 400,
    //   betaward_fetch: 0,
    //   betaward_can: 0,
    //   payfee: 1000,
    //   rdate: '2024-08-05 14:45:43',
    //   userid: 16337619,
    //   bet60awardflag: 0
    // };
    if (!data) {
      rechargeStore.firstRecharge = {
        ...rechargeStore.firstRecharge,
        ready: true,
        dailyFirstEnter: Storage.get(FIRST_RECHARGE_DAILY_FIRST_ENTER)
      };
      return;
    }
    rechargeStore.firstRecharge = {
      ...this.firstRecharge,
      ...data,
      rechargeTime: data.paytime,
      hasBonus: false,
      rechargeAmount: data.payfee,
      dailyFirstEnter: Storage.get(FIRST_RECHARGE_DAILY_FIRST_ENTER)
    };
  },
  async updateContinueRechargeData() {
    const { record } = await continueRechargeApi.getContinueRecharge();
    // @ts-ignore
    rechargeStore.continueRecharge.list = [
      // {
      //   paytime: '2024-07-21',
      //   pay_level: 201,
      //   expdate: '2024-07-28',
      //   payfee: 200,
      //   bet: 100,
      //   awardbet40: 100,
      //   awardbet40_fetch: 0,
      //   bet60awardflag: 0,
      //   betaward: 0,
      //   betaward_can: 0,
      //   betaward_fetch: 0
      // },
      { paytime: '', pay_level: 201 },
      { paytime: '', pay_level: 202 },
      { paytime: '', pay_level: 203 }
    ].map(item => {
      const target = (record || []).find(recordItem => recordItem.pay_level === item.pay_level);
      return {
        ...item,
        ...(target || {})
      };
    });
  },
  async updateRechargeData() {
    Promise.all([rechargeStore.updateFirstRechargeData(), rechargeStore.updateContinueRechargeData()]).finally(() => {
      rechargeStore.loaded = true;
    });
  }
});

// 此处使用了别的store，不加setTimeout 会报错
setTimeout(() => {
  reaction(
    () => [
      globalStore.initialState.registerDate,
      rechargeStore.firstRecharge.dailyFirstEnter,
      rechargeStore.firstRecharge.rechargeTime
    ],
    () => {
      rechargeStore.updateFirstRechargeShow();
      rechargeStore.firstRecharge.ready = true;
    }
  );
}, 0);
reaction(
  () => [rechargeStore.firstRecharge],
  () => {
    rechargeStore.updateFirstRechargeHasBonus();
  }
);

reaction(
  () => [rechargeStore.continueRecharge.list],
  () => {
    rechargeStore.updateContinueShow();
    rechargeStore.updateContinueCanRecharge();
    rechargeStore.updateContinueHasBonus();
  }
);

export default rechargeStore;
